import { render, staticRenderFns } from "./InfoBuy.vue?vue&type=template&id=2336b8f3&scoped=true&"
import script from "./InfoBuy.vue?vue&type=script&lang=js&"
export * from "./InfoBuy.vue?vue&type=script&lang=js&"
import style0 from "./InfoBuy.vue?vue&type=style&index=0&id=2336b8f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336b8f3",
  null
  
)

export default component.exports